import { PropsWithChildren } from "react";

const CardWrapperV2 = ({
  children,
  className = "",
}: PropsWithChildren<{ className?: string }>): JSX.Element => {
  return (
    <div
      className={`mb-3 w-full pr-3 tablet:max-w-full tablet:px-[0.625rem] ${className}`}
    >
      {children}
    </div>
  );
};

export default CardWrapperV2;
